// Assistant translations for integration with i18next
const translations = {
  'en-US': {
    assistant: {
      browser_welcome: 'Kickstart your experience with CIQ agents. Choose an agent to get started.',
      untitled_chat: 'Untitled chat',
      agents: {
        'planexecution.assistant.plan_document_agent': {
          name: 'Plan docs explainer',
          short_description: 'Comprehensive breakdowns of your plan documents',
          medium_description: 'Comprehensive breakdowns of your plan documents.',
          prompts: [
            'Give me a high level overview of my plan doc',
            'How much commission would I earn on a $500K deal?',
            'Explain how accelerators work in my plan',
          ],
        },
        'payouts.assistant.payouts_info_agent': {
          name: 'Payout statement explainer',
          short_description: 'Get help understanding a payout statement',
          medium_description: 'Get help understanding a payout statement.',
          prompts: [
            'What are my total earnings and what are they made of?',
            'What share of my total payout was SPIF?',
            'Show me which deals contributed the most to my payout.',
          ],
        },
        'payouts.assistant.comp_ops_agent': {
          name: 'Comp Ops Agent',
          short_description: 'Process and manage payout workflows',
          medium_description: 'Process payout workflows, preview calculations, and manage delivery operations.',
          prompts: [
            'Show me the current payout workflows',
            'Preview the processing results for this period',
            "What's the status of the latest payout run?",
          ],
        },
        'worksheets.comp_builder_agent': {
          name: 'Comp Builder Agent',
          short_description: 'Build, analyze, and fix commission calculations',
          medium_description:
            'Understand how commission calculations work, trace dependencies, analyze formula logic, and create or modify columns.',
          prompts: ['Explain this formula', 'What depends on this column?', 'Show me the calculation flow'],
        },
        'catalyst.ml.training_run_explainer': {
          name: 'ML Training Explainer',
          short_description: 'Understand machine learning training runs and models',
          medium_description:
            'Analyze ML training performance, understand model behavior, and optimize training processes.',
          prompts: [
            'Explain the results of my latest training run',
            'Why is my model accuracy not improving?',
            'Help me understand the feature importance in my model',
          ],
        },
        'catalyst.ml.prediction_explainer': {
          name: 'ML Prediction Explainer',
          short_description: 'Understand anomaly detection predictions and insights',
          medium_description:
            'Analyze anomaly detection results, understand what drove anomaly scores, and interpret predictions.',
          prompts: [
            'Why was this record flagged as an anomaly?',
            'What factors made this prediction unusual?',
            'Help me understand what drove this anomaly score',
          ],
        },
        'disputes.inquiries': {
          name: 'Inquiries Assistant',
          short_description: 'Handle customer inquiries and disputes',
          medium_description: 'Process customer inquiries, resolve disputes, and provide detailed analysis.',
          prompts: [
            'Help me understand this customer inquiry',
            "What's the best way to resolve this dispute?",
            'Analyze the patterns in recent inquiries',
          ],
        },
        'payee.assistant.payee_agent': {
          name: 'Payee Assistant',
          short_description: 'Comprehensive payee support and guidance',
          medium_description: 'Get help with payee-related questions, commission calculations, and plan understanding.',
          prompts: [
            'Explain my commission structure',
            'How do I maximize my earnings this quarter?',
            'Help me understand my performance metrics',
          ],
        },
        'payee.assistant.what_if_agent': {
          name: 'What-If scenario resolver',
          short_description: 'Explore hypothetical deals',
          medium_description: 'Ask hypothetical questions. Get real calculation results.',
          prompts: [],
        },
        'worksheets.kits.transformation': {
          name: 'Data Transformation',
          short_description: 'Data transformation and processing assistance',
          medium_description: 'Help with data transformations, calculations, and worksheet processing.',
          prompts: [
            'Help me transform this data for analysis',
            'Explain how to calculate these metrics',
            'Optimize my data processing workflow',
          ],
        },
        'catalyst.epm.agent': {
          name: 'Catalyst Agent',
          short_description: 'Forecast payouts, build budgets, and plan workflows',
          medium_description:
            'Generate ML-powered payout forecasts, create planning models, link budgets to rollups, and build complete EPM workflows.',
          prompts: [
            'Help me generate a payout forecast',
            'Help me get set up with an EPM workspace',
            'Help me set up some models in this workspace',
          ],
        },
        'tq.account_dealer': {
          name: 'Account Dealer',
          short_description: 'Design and refine account-to-territory assignment rules',
          medium_description:
            'Get help configuring Account Dealer rules — filters, distribution methods, optimization, and more.',
          prompts: [
            'Show me the current account dealer configuration for this territory',
            'Help me balance accounts evenly across territories',
            'Help me set up a new account dealer rule for this territory',
          ],
        },
        'tq.revops_agent': {
          name: 'Revenue Planning Agent',
          short_description: 'Your guide to sales planning',
          medium_description:
            'Get Sales Planning help - from territory hierarchies and account assignments to quota worksheets and formula dependencies.',
          prompts: [
            'Describe my planning cycle',
            'Help me understand how my final quotas are calculated',
            'Summarize the territories and accounts assigned',
          ],
        },
        'audit.assistkit.audit_logs_agent': {
          name: 'Audit Logs Agent',
          short_description: 'Analyze and understand audit logs',
          medium_description:
            'Get insights from audit logs, identify patterns, and understand user activities and system events.',
          prompts: [
            'Show me all the password change events for all users in the last month',
            'Help me find a worksheet change that happened last week',
            'Help me analyze payout changes for a specific user',
          ],
        },
        'epm.financial_model.builder': {
          name: 'EPM Financial Model Builder',
          short_description: 'Build and configure planning components for your financial model',
          medium_description:
            'Build Manual planning components with the right measure type, dimensions, and rollup wiring.',
          prompts: ['Set up a new workspace and model for planning', 'Create a new manual planning component'],
        },
        // Not offered in the agent browser (see PRODUCTION_READY_AGENT_NAMES). Its threads come from
        // Ask AI in the command bar, and this metadata is what the History tab renders for them.
        'helpbar.assistkit.helpbar_docs': {
          name: 'Documentation Assistant',
          short_description: 'Answers product questions from the CaptivateIQ documentation',
          medium_description:
            'Searches the CaptivateIQ product documentation and answers questions about features, configuration, and workflows.',
          prompts: [
            'How do I schedule a recurring payout?',
            'How do I decline a payout review?',
            'How do I import users from a CSV?',
          ],
        },
      },
      input_placeholders: {
        message: 'Chat',
        search: 'Search chats',
      },
      button_labels: {
        load_more: 'Load more',
        new_chat: 'New Chat',
        chat: 'Chat',
        history: 'History',
        back: 'Back',
        expand: 'Expand',
        collapse: 'Collapse',
      },
      messages: {
        no_chats: 'No chats yet. Start a new chat and it will appear here.',
        error_loading_chats: 'Error loading chats. Please try again.',
        error_loading_message_history: 'Error loading message history. Please try again.',
        error_creating_conversation: 'Error creating conversation. Please try again.',
        error_sending_message: 'Error sending message. Please try again.',
        thinking: 'Thinking...',
      },
      app_actions: {
        navigate_to_worksheet: 'Worksheet ready',
      },
    },
  },
};

export default translations;
